export function getCloudHostname(): string {
  if (process.env.REACT_APP_OMNI_CORE_MOCK_API === 'true') {
    return '/api';
  }
  return process.env.REACT_APP_CLOUD_HOST_NAME ?? '';
}
